import React from "react";
import { Form, Select } from "antd";
import filterConnect from "../../../../common/hoc/filterConnect";

const { Option } = Select;

const SurchargePayment = ({ form, disabled, parent, paymentMethods }) => {
  const { getFieldDecorator } = form;

  return (
    <div className="offer-card__item">
      {parent === "order" ? (
        <span className="label">Способ доплаты по заказу (С1):</span>
      ) : (
        <span className="label" style={{ lineHeight: "normal" }}>
          Способ доплаты по предложению:
        </span>
      )}

      <Form.Item>
        {getFieldDecorator("priceAddPayment", {
          rules: [
            {
              required: true,
              message: "Поле, обязательное для заполнения"
            }
          ]
        })(
          <Select
            getPopupContainer={trigger => trigger.parentNode}
            style={{ width: 368 }}
            disabled={disabled}
            placeholder="Выберите способ доплаты"
          >
            {paymentMethods &&
              paymentMethods.map(item => (
                <Option
                  value={item.paymentMethodId}
                  key={item.paymentMethodKey}
                >
                  {item.paymentMethod}
                </Option>
              ))}
          </Select>
        )}
      </Form.Item>
    </div>
  );
};

export default filterConnect(SurchargePayment, ["paymentMethods"]);
